export enum RequestContext {
    Registration= 'REGISTRATION',
    Settings = 'SETTINGS',
    PreferenceCard = 'PREFERENCE_CARD'
}
